import './Works.css';

function Works(){

    return(
        <div id="services">
        <div className="container">
            <h1 className="sub-title">My Working</h1>
            <div className="services-list">
                <div>
                    <i className="fa-solid fa-code"></i>
                    <h2>
                        MERN Stack Development
                    </h2>
                    <p>Passion-driven learner and a web developer with the ability to write clean, reusable,
                        optimised code. Skilled and experienced at bulding and maintaining of web development.
                        Looking forward to joining a progressive and challenging work environment.</p>
                    <a href="https://github.com/sikendrakumarverma"> See more</a>
                </div>
                <div>
                    <i className="fa-solid fa-crop"></i>
                    <h2>
                        Back-End Development
                    </h2>
                    <p>Enjoy the process of building the Back-End API's from scratch. Solving the problems 
                        and finding the best solutions is a creative process which often pushes me to leaving 
                        from my comfort zone and this is when we are growing.
                    </p>
                    <a href="https://github.com/sikendrakumarverma"> See more</a>
                </div>
                <div>
                    {/* <i className="fa-brands fa-apple"></i> */}
                    <i className="fa-solid fa-code"></i>
                    <h2>
                        Web App Development
                    </h2>
                    <p>Enthusiatic and Hardworking, want to learn more about App Development by putting more effort to achieve 
                        that goal, so Looking for an opportunity to work in suitable position and technology-driven organisation.</p>
                    <a href="https://github.com/sikendrakumarverma"> See more</a>
                </div>
            </div>
        </div>
    </div>
    )
}

export default Works;